<template>
  <div :class="[bgColor, 'forget-pwd','login-new']">
    <p class="title">{{ $t("forget_password.nav_title") }}</p>
    <p class="sub-title">{{ $t("forget_password.first_step_desc") }}</p>
    <div class="form">
      <div class="ipt-item phone">
        <customField
          v-model="form.phone"
          type="number"
          :placeholder="$t('login.phone_placeholder')"
        >
          <template slot="prev">
            <div class="country-code" @click="showZoneCodePicker = true">
              <span>+{{ form.zone_code }}</span>
            </div>
          </template>
          <template slot="next" v-if="form.phone && form.phone.length > 0">
            <div class="icon-box" @click="clearPhone"><van-icon name="clear" color="#888" /></div>
          </template>
        </customField>
      </div>
      <div class="ipt-item">
        <custom-field
          :placeholder="$t('register.captcha_placeholder')"
          v-model="form.captcha"
          :maxlength="4"
        >
          <template slot="next">
            <div class="captcha-wrap" @click="handleGetCaptcha">
              <img v-if="img" :src="img" alt="" />
              <van-loading
                class="captcha-loading"
                v-if="isCaptchaLoading"
                size="16"
                type="spinner"
              />
              <van-icon
                class="captcha-error"
                v-if="isCaptchaError && !img"
                name="close"
                color="#E83324"
              />
            </div>
          </template>
        </custom-field>
      </div>
      <div class="ipt-item">
        <custom-field
          :placeholder="$t('register.message_code_placeholder')"
          v-model="form.code"
          :maxlength="6"
        >
          <template slot="next">
            <button
              :class="[
              'verCode-btn',
              isSendVerCode ? 'verCode-btn--disabled' : 'verCode-btn--normal'
            ]"
              :disabled="isSendVerCode"
              @click="handleSendVerCode"
            >
              {{
                isSendVerCode
                  ? `(${verCodeTime}s)`
                  : $t("register.send_message_btn_text")
              }}
            </button>
          </template>
        </custom-field>
      </div>
      <div class="empty"></div>
      <div class="btn-submit mb0" :class="{dis: isDisabledSubmit}" @click="submit">{{ $t("common.confirm") }}</div>

    </div>
    <!-- <TelActions></TelActions> -->
    <p class="text">{{ $t('findPwd.t00001') }} <a class="btn" @click="showActionSheet = true">{{ $t('openAccount.t000023') }}</a></p>
    <GlobalActionSheet v-if="showActionSheet" v-model="showActionSheet"></GlobalActionSheet>
    <van-popup v-model="showZoneCodePicker" position="bottom" class="picker-ui">
      <van-picker
        show-toolbar
        :columns="zoneCodeList"
        :default-index="currentZoneCodeIndex"
        @confirm="handleConfirmZoneCode"
        @cancel="showZoneCodePicker = false"
      />
    </van-popup> 
  </div>
</template>

<script>
import customField from "@/components/customField/index.vue";
import TelActions from "./components/TelActions.vue";
import { Button, Toast, Popup, Picker, Loading, Icon, Checkbox } from "vant";
import { isChinaPhone, isHKPhone } from "@/utils/verify";
import GlobalActionSheet from "@/components/GlobalActionSheet.vue";
import {
  buildAreaCodePickerOptions,
  initDefaultAreaCode,
  getAreaCodePickerIndex
} from "@/utils/areaCodeList";

export default {
  components: { 
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    customField: customField,
    [Checkbox.name]: Checkbox,
    TelActions,
    GlobalActionSheet
  },
  computed: {
    bgColor(){
      return this.$store.getters["common/bgColor"];
    },
    isDisabledSubmit() {
      return Object.keys({
        phone: this.form.phone,
        captcha: this.form.captcha,
        key: this.form.key,
        code: this.form.code,
        zone_code: this.form.zone_code
      }).some(key => {
        return !this.form[key];
      });
    },
    zoneCodeList() {
      return buildAreaCodePickerOptions(this.$i18n);
    }
  },
  data(){
    return {
      form: {
        phone: "",
        code: "",
        zone_code: 852,
        area_code_id: "", // 新增区号ID
        login_type: 2,
        source: "app"
      },
      showActionSheet: false,
      showZoneCodePicker: false,
      currentZoneCodeIndex: 0, // 新增：当前区号选中的索引

      isCaptchaLoading: true,
      isCaptchaError: false,
      img: '',
      verCodeTime: 120,

      isSendVerCode: false,
    }
  },
  activated() {
    const fromPath = localStorage.getItem("fromPath");
    if(fromPath == '/login-new'){
      this.form = {
        phone: "",
        code: "",
        zone_code: 852,
        area_code_id: "", // 新增区号ID
        login_type: 2,
        source: "app"
      }
      // 重新设置默认区号ID
      const defaultItem = this.zoneCodeList.find(item => item.value == "852");
      if (defaultItem) {
        this.form.area_code_id = defaultItem.id;
        this.currentZoneCodeIndex = this.zoneCodeList.findIndex(item => item.id === defaultItem.id);
      }
      clearInterval(this.verCodeTimer);
      this.verCodeTime = 120;
      this.isSendVerCode = false;
      this.handleGetCaptcha();
    }
  },
  created(){
    initDefaultAreaCode(this.form);
    this.currentZoneCodeIndex = getAreaCodePickerIndex(
      this.zoneCodeList,
      this.form.area_code_id
    );
    this.handleGetCaptcha();
  },
  methods:{
    clearPhone(){
      this.form.phone = '';
    },
    handleConfirmZoneCode(e){
      this.form.zone_code = e.value;
      this.form.area_code_id = e.id; // 同时保存区号ID
      this.currentZoneCodeIndex = this.zoneCodeList.findIndex(item => item.id === e.id);
      this.showZoneCodePicker = false;
    },
    handleGetCaptcha() {
      this.isCaptchaLoading = true;
      this.isCaptchaError = false;
      this.$apis
        .getCaptcha()
        .then(res => {
          this.isCaptchaLoading = false;
          const { key, img } = res;
          this.form.key = key;
          this.img = img;
        })
        .catch(e => {
          this.isCaptchaLoading = false;
          this.isCaptchaError = true;
          
        });
    },
    verifyPhone() {
      let is = false;
      if (this.form.zone_code == "86") {
        is = isChinaPhone(this.form.phone);
      } else if (this.form.zone_code == "852") {
        is = isHKPhone(this.form.phone);
      }
      return is;
    },
    handleSendVerCode(){
      // if (!this.verifyPhone())
      //   return this.$toast.fail(this.$t("common.phone_verify_fail_text"));
      if (!this.form.captcha)
        return this.$toast.fail(this.$t("common.captcha_verify_fail_text"));
      // 校验验证码
      this.$apis.verifyCaptcha({
        captcha: this.form.captcha,
        key: this.form.key,
      }).then(res => {
        if(res.code){
          return;
        }
        // 发送验证码
        const params = {
          phone: this.form.phone,
          zone_code: this.form.zone_code,
          area_code_id: this.form.area_code_id, // 新增区号ID参数
          msg_show: 1,
          type: 3
        }
        this.$apis.sendVerCode(params)
          .then(res => {
            
            if(!(res.code && res.msg)){
              Toast(this.$t("common.message_send_success_text"));
              // const { code } = res;
              // this.form.code = code;
              this.isSendVerCode = true;
              this.setIntervalSendCode();
            }
          })
      })
    },
    setIntervalSendCode() {
      const now = new Date().getTime();
      const end = new Date(now + this.verCodeTime * 1000).getTime();
      this.verCodeTimer = setInterval(() => {
        this.verCodeTime = Math.ceil((end - new Date().getTime()) / 1000);
        if (this.verCodeTime <= 0) {
          clearInterval(this.verCodeTimer);
          this.verCodeTime = 120;
          this.isSendVerCode = false;
        }
      }, 1000);
    },
    submit(){
      if(this.isDisabledSubmit){
        return ;
      }
      const params = {
        phone: this.form.phone,
        zone_code: this.form.zone_code,
        area_code_id: this.form.area_code_id, // 新增区号ID参数
        captcha: this.form.captcha,
        key: this.form.key,
        code: this.form.code,
      }
      this.$apis.resetPassword1Api(params).then(res => {
        if(res.sign){
          let nextPath = '/login-password-forget/step-second'
          if(!res.step){
            nextPath = '/login-password-forget/step-third'
          }
          this.$router.push({
            path: nextPath,
            query: {
              sign: res.sign,
              user_no: res.user_no
            }
          });
        }
      })
    }
  }
}
</script>


<style scoped lang="less">
@import "../login-new/components/form.comon.less";
.text{
  text-align: center;
  margin-top: 20px;
  a{
    color: #328CF4;
  }
}
</style>